export default function SettingsPage() {
  return <h2>⚙️ Settings Page</h2>;
}
